var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{style:({ color: _vm._CssColor }),attrs:{"icon":_vm.icon,"pack":_vm.pack,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }